import React, {ChangeEventHandler, FC} from 'react';
import classes from './textarea.module.sass'

interface Props {
    label: string;
    value: string;
    name: string;
    onChange: ChangeEventHandler<HTMLTextAreaElement>;
    className: string;
}

const Textarea: FC<Props> = (
    {
        label,
        value,
        onChange,
        name,
        className,
    }
) => {
    return (
        <label className={classes.input + ' ' + className}>
            <span>{label} <span>*</span></span>
            <textarea name={name} rows={5} value={value} onChange={onChange} />
            {
                 className.includes('invalid')
                     ? value.length !== 0
                        ? <span className={className + ' ' + 'span'}>Message is too short</span>
                        : <span className={className + ' ' + 'span'}>Required field</span>
                     : null
            }
        </label>
    );
};

export default Textarea;